import React from 'react'
import {
  CustomerAgencyDocumentQueryAuditSnapshotV1,
  IAuditEventData,
} from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveEventData } from './utils'
import { DetailField } from './DetailField'

interface CustomerAgencyDocumentQueryDetailsProps {
  eventData: IAuditEventData
}

export const CustomerAgencyDocumentQueryDetails: React.FunctionComponent<CustomerAgencyDocumentQueryDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const info = resolveEventData<CustomerAgencyDocumentQueryAuditSnapshotV1>(
    eventData,
    nameof<CustomerAgencyDocumentQueryAuditSnapshotV1>(),
  )

  if (!info) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField label="Document Type" original={info.documentType} />

        <DetailField label="Search Field" original={info.searchField} />

        <DetailField label="Search Value" original={info.searchValue} />
      </Box>
    </React.Fragment>
  )
}
